export default function Clientes() {
    return (
        <div className="area-clientes">
            <div className="conteudo">
                <h3>Clientes</h3>
                <p>Em breve...</p>
            </div>
        </div>
    )
}